
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { CostCentreEntityDecorator } from '../../costcentre/model/cost-centre.decorator';
import { CostCentre } from '../../costcentre/model/cost-centre.model';
import { ASSETS_USER_DETAILS_METADATA } from './assets-user-details.metadata';
import { AssetsUserDetails } from './assets-user-details.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class AssetsUserDetailsEntityDecoratorBase extends GenericEntityDecorator<AssetsUserDetails, string> {
  constructor() {
    super(ASSETS_USER_DETAILS_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get costCentres(): EntityDecorator<CostCentre, string> {
        return new CostCentreEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): string {
    if (params == null || params.user == null) {
      return null;
    }
    return params.user;
  }
  toKeyUrlPathSegments(key: string): string {
    if (key == null) {
      return null;
    }
    return key;
  }
  toKeyRouteSegments(item: AssetsUserDetails): any[] {
    const key: string = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




